"use client";

import { useSearchParams } from "next/navigation";

const useCapturePageHit = () => {
    const searchParams = useSearchParams();
    const parameters = {};

    const changeState = (param, key) => {
        if (param?.has(key) && param?.get(key)?.length > 0) {
            parameters[key] = param.get(key);
        } else {
            parameters[key] =
                key === "utm_campaign"
                    ? "999"
                    : key === "utm_term"
                        ? "Unknown"
                        : "Organic";
        }
    };

    if (searchParams) {
        changeState(searchParams, "utm_source");
        changeState(searchParams, "utm_medium");
        changeState(searchParams, "utm_campaign");
        changeState(searchParams, "utm_content");
        changeState(searchParams, "utm_term");

        // Get the full URL (window.location.href can only be accessed in client-side)
        if (typeof window !== "undefined") {
            parameters["entire_url"] = window.location.href;
        }
    }

    if (typeof localStorage !== "undefined") {
        const storedParams = localStorage.getItem("urlParams");

        if (!storedParams) {
            localStorage.setItem("urlParams", JSON.stringify(parameters));
        } else {
            const parsedParams = JSON.parse(storedParams);
            if (
                searchParams.toString().length > 0 &&
                parsedParams?.utm_campaign !== searchParams.get("utm_campaign")
            ) {
                localStorage.setItem("urlParams", JSON.stringify(parameters));
            }
        }
    }
    return parameters;
};

export default useCapturePageHit;
